import { __ } from '@wordpress/i18n';

const EnhancedPreviewFieldContent = ({ field, area }) => {
  // Special handling for footer-left area to match existing markup
  if (area === 'footer-left') {
    switch (field.type) {
      case 'view-btn':
        return (
          <button className="hvnly--builder---api_property__builder___enhanced_preview_card_button hvnly--builder---api_property__builder___enhanced_preview_card_primary_btn">
            <i className="fas fa-external-link-alt"></i> {field.value?.text || __('View Property', 'havenlytics')}
          </button>
        );
      case 'schedule-tour-button':
        return (
          <button className="hvnly--builder---api_property__builder___enhanced_preview_card_button hvnly--builder---api_property__builder___enhanced_preview_card_primary_btn">
            <i className="fas fa-calendar-alt"></i> {field.value?.text || __('Schedule Tour', 'havenlytics')}
          </button>
        );
      case 'badge':
        return (
          <span className="hvnly--builder---api_property__builder___enhanced_preview_card_tag">
            {field.value?.text || __('Featured', 'havenlytics')}
          </span>
        );
      case 'status':
        return (
          <span className={`hvnly--builder---api_property__builder___enhanced_preview_card_status hvnly-status-${field.value?.color || 'green'}`}>
            <i className="fas fa-circle"></i> {field.value?.text || __('Active', 'havenlytics')}
          </span>
        );
      case 'time':
        return (
          <span className="hvnly--builder---api_property__builder___enhanced_preview_card_time">
            <i className="fas fa-clock"></i> {field.value?.text || __('2 days ago', 'havenlytics')}
          </span>
        );
      default:
        return <span>{field.value?.text || field.label}</span>;
    }
  }
  
  // Special handling for footer-right area to match existing markup
  if (area === 'footer-right') {
    switch (field.type) {
      case 'share':
        return (
          <button className="hvnly--builder---api_property__builder___enhanced_preview_card_action_btn">
            <i className="fas fa-share-alt"></i>
          </button>
        );
      case 'favorite':
        return (
          <button className="hvnly--builder---api_property__builder___enhanced_preview_card_action_btn">
            <i className={`fas fa-heart ${field.value?.isFavorite ? 'active' : ''}`}></i>
          </button>
        );
      case 'rating':
        return (
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_rating">
            <div className="hvnly--builder---api_property__builder___enhanced_preview_card_stars">
              {[...Array(5)].map((_, i) => (
                <i 
                  key={i} 
                  className={`fas fa-star ${i < Math.floor(field.value?.value || 0) ? 'filled' : ''}`}
                ></i>
              ))}
            </div>
            <span className="hvnly--builder---api_property__builder___enhanced_preview_card_rating_value">
              {field.value?.value || 4.5}
            </span>
            <span className="hvnly--builder---api_property__builder___enhanced_preview_card_rating_reviews">
              ({__('120 reviews', 'havenlytics')})
            </span>
          </div>
        );
      case 'views':
        return (
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_views">
            <i className="fas fa-eye"></i>
            <span>{field.value?.count || 245} {__('views', 'havenlytics')}</span>
          </div>
        );
      default:
        return <span>{field.value?.text || field.label}</span>;
    }
  }
  
  // Handle all other areas with existing code
  switch (field.type) {
    case 'image':
      if (area === 'avatar') {
        return (
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_avatar">
            <i className="fas fa-user"></i>
          </div>
        );
      }
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_bg">
          {/* <i className="fas fa-image"></i> */}
        </div>
      );
    case 'carousel':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_image_bg">
          {/* <i className="fas fa-images"></i> */}
        </div>
      );
    case 'badge':
      return <span className="hvnly--builder---api_property__builder___enhanced_preview_card_tag">{field.value?.text}</span>;
    case 'favorite':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_favorite">
          <i className={`fas fa-heart ${field.value?.isFavorite ? 'active' : ''}`}></i>
        </div>
      );
    case 'share':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_share">
           <i className="fas fa-share-alt"></i>
        </div>
      );
    case 'title':
      return <h3 className="hvnly--builder---api_property__builder___enhanced_preview_card_title">{field.value?.text}</h3>;
    case 'rating':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_rating">
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_stars">
            {[...Array(5)].map((_, i) => (
              <i key={i} className={`fas fa-star ${i < Math.floor(field.value?.value || 0) ? 'filled' : ''}`}></i>
            ))}
          </div>
          <span className="hvnly--builder---api_property__builder___enhanced_preview_card_rating_value">{field.value?.value}</span>
          <span className="hvnly--builder---api_property__builder___enhanced_preview_card_rating_reviews">({__('120 reviews', 'havenlytics')})</span>
        </div>
      );
    case 'phone':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_detail_item">
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_detail_icon">
            <i className="fas fa-phone"></i>
          </div>
          <span>{field.value?.number}</span>
        </div>
      );
    case 'email':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_detail_item">
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_detail_icon">
            <i className="fas fa-envelope"></i>
          </div>
          <span>{field.value?.address}</span>
        </div>
      );
    case 'website':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_detail_item">
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_detail_icon">
            <i className="fas fa-globe"></i>
          </div>
          <span>{field.value?.url}</span>
        </div>
      );
    case 'datetime':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_detail_item">
          <div className="hvnly--builder---api_property__builder___enhanced_preview_card_detail_icon">
            <i className="fas fa-clock"></i>
          </div>
          <span>{field.value?.text}</span>
        </div>
      );
    case 'property_type':
      return (
        <span className="hvnly--builder---api_property__builder___enhanced_preview_card_property_type">
          {field.value?.text || __('Property Type', 'havenlytics')}
        </span>
      );
    case 'views':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_views">
          <i className="fas fa-eye"></i>
          <span>{field.value?.count || 0} {__('views', 'havenlytics')}</span>
        </div>
      );
    case 'price':
      return <div className="hvnly--builder---api_property__builder___enhanced_preview_card_price">${field.value?.value || '0'}</div>;
    case 'price-per-sqft':
      return <span>${field.value?.value || '0'}/sq ft</span>;
    case 'beds':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className="fas fa-bed"></i>
          <span>{field.value?.value || '0'} {__('Beds', 'havenlytics')}</span>
        </div>
      );
    case 'baths':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className="fas fa-bath"></i>
          <span>{field.value?.value || '0'} {__('Baths', 'havenlytics')}</span>
        </div>
      );
    case 'receptions':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className="fas fa-door-open"></i>
          <span>{field.value?.value || '0'} {__('Receptions', 'havenlytics')}</span>
        </div>
      );
    case 'sqft':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className="fas fa-ruler-combined"></i>
          <span>{field.value?.value || '0'} {__('sq ft', 'havenlytics')}</span>
        </div>
      );
    case 'view-btn':
      return (
        <button className="hvnly--builder---api_property__builder___enhanced_preview_card_button hvnly--builder---api_property__builder___enhanced_preview_card_primary_btn">
          <i className="fas fa-external-link-alt"></i> {field.value?.text || __('View Property', 'havenlytics')}
        </button>
      );
    case 'schedule-tour-button':
      return (
        <button className="hvnly--builder---api_property__builder___enhanced_preview_card_button hvnly--builder---api_property__builder___enhanced_preview_card_primary_btn">
          <i className="fas fa-calendar-alt"></i> {field.value?.text || __('Schedule Tour', 'havenlytics')}
        </button>
      );
    case 'feature':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className={`fas fa-${field.value?.icon || 'star'}`}></i>
          <span>{field.value?.label || __('Feature', 'havenlytics')}</span>
        </div>
      );
    case 'excerpt':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_excerpt">
          <p>{field.value?.text || __('Property excerpt', 'havenlytics')}</p>
        </div>
      );
    case 'location':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_location">
          <i className="fas fa-map-marker-alt"></i>
          <span>{field.value?.text || __('Property location', 'havenlytics')}</span>
        </div>
      );
    case 'kitchens':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className="fas fa-utensils"></i>
          <span>{field.value?.value || '0'} {__('Kitchens', 'havenlytics')}</span>
        </div>
      );
    case 'floor':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className="fas fa-layer-group"></i>
          <span>{field.value?.value || '0'} {__('Floor', 'havenlytics')}</span>
        </div>
      );
    case 'rooms':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className="fas fa-door-closed"></i>
          <span>{field.value?.value || '0'} {__('Rooms', 'havenlytics')}</span>
        </div>
      );
    case 'gsft':
      return (
        <div className="hvnly--builder---api_property__builder___enhanced_preview_card_feature_item">
          <i className="fas fa-warehouse"></i>
          <span>{field.value?.value || '0'} {__('Gsq ft', 'havenlytics')}</span>
        </div>
      );
    case 'status':
      return (
        <span className={`hvnly--builder---api_property__builder___enhanced_preview_card_status hvnly-status-${field.value?.color || 'green'}`}>
          <i className="fas fa-circle"></i> {field.value?.text || __('Status', 'havenlytics')}
        </span>
      );
    case 'time':
      return (
        <span className="hvnly--builder---api_property__builder___enhanced_preview_card_time">
          <i className="fas fa-clock"></i> {field.value?.text || __('Time', 'havenlytics')}
        </span>
      );
    default:
      return <span>{field.value?.text || field.label}</span>;
  }
};

export default EnhancedPreviewFieldContent;